import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/layout/Index.vue'
import Login from '@/views/login/Index.vue'
import Home from '@/views/home/Home.vue'

// 商品
const Commodity = () => import('@/views/commodity/Commodity.vue')//商品


// 线上订单
const Order = () => import('@/views/order/Order.vue')//订单
const OrderList = () => import('@/views/order/list/OrderList.vue')//订单列表
const WorkList = () => import('@/views/order/work/WorkList.vue')//工单列表
const CommodityList = () => import('@/views/commodity/list/ProductList.vue')//商品列表
const OnlineProductChannel = () => import('@/views/commodity/list/OnlineProductChannel.vue')//线上渠道商品
const Category = () => import('@/views/commodity/category/Category.vue')//商品分类
//生产(线上)
const Produce = () => import('@/views/produce/Produce.vue')//生产
const ClothingList = () => import('@/views/produce/clothing/ClothingList.vue')//衣物列表
const EnterFactory = () => import('@/views/produce/clothing/EnteringFactory.vue')//衣物分检
const ClothingInspection = () => import('@/views/produce/clothing/ClothingInspection.vue')//衣物总检
const LeavingFactory = () => import('@/views/produce/clothing/LeavingFactory.vue')//衣物出厂
// 门店
const StoreParentOrder = () => import('@/views/store/manage/StoreParentOrder.vue')//门店订单
const StoreOrder = () => import('@/views/store/manage/StoreOrder.vue')//门店衣物
const StoreProduct = () => import('@/views/store/manage/StoreProduct.vue')//门店商品
const StoreProductChannel = () => import('@/views/store/manage/StoreProductChannel.vue')//门店渠道商品
const StoreCommodity = () => import('@/views/store/manage/StoreCommodity.vue')//商品分类
const BookOrder = () => import('@/views/store/manage/BookOrder.vue')//网约订单
const CollectionPoint = () => import('@/views/store/manage/CollectionPoint.vue')//门店列表
// 生产(门店)
const SortingStore = () => import('@/views/store/produce/SortingStore.vue')//衣物分检
const PlaceOrderStore = () => import('@/views/store/produce/PlaceOrderStore.vue')//门店下单
const GarmentStore = () => import('@/views/store/produce/GarmentStore.vue')//门店收衣
const OutboundStore = () => import('@/views/store/produce/OutboundStore.vue')//衣物出库
// 商城
const Mall = () => import('@/views/mall/Mall.vue')//商城
const MallProduct = () => import('@/views/mall/manage/MallProduct.vue')//商城商品
const MallProductChannel = () => import('@/views/mall/manage/MallProductChannel.vue')//商城渠道商品
const MallCommodity = () => import('@/views/mall/manage/MallCommodity.vue')//商品分类
const MallOrder = () => import('@/views/mall/manage/MallOrder.vue')//商城订单
const InternalShipment = () => import('@/views/mall/manage/InternalShipment.vue')//供应商发货
const SupplierAccount = () => import('@/views/mall/manage/SupplierAccount.vue')//供应商快递
const SupplierCompany = () => import('@/views/mall/manage/SupplierCompany.vue')//供应商公司
const UserAddress = () => import('@/views/mall/user/UserAddress.vue')//用户地址列表
const UserList = () => import('@/views/mall/user/User.vue')//用户列表
const ShoppingList = () => import('@/views/commodity/shopping/ShoppingList.vue')//购物车列表
// 渠道订单
const OnlineOrder = () => import('@/views/channel/OnlineOrder.vue')//线上订单列表
const OfflineOrder = () => import('@/views/channel/OfflineOrder.vue')//门店订单列表
const MallSmallOrder = () => import('@/views/channel/MallSmallOrder.vue')//商城订单列表
// 营销
const MemberDiscount = () => import('@/views/marke/MemberDiscount.vue')//会员折扣
const GroupManage = () => import('@/views/marke/GroupManage.vue')//团单管理
const CommissionMember = () => import('@/views/marke/CommissionMember.vue')//分销管理
const DistributionRecords = () => import('@/views/marke/DistributionRecords.vue')//分销记录
const ChannelList = () => import('@/views/marke/ChannelList.vue')//渠道列表
const VoucherManagement = () => import('@/views/marke/VoucherManagement.vue')//代金券管理
const VoucherRecord = () => import('@/views/marke/VoucherRecord.vue')//代金券记录
const CarouselImage = () => import('@/views/marke/CarouselImage.vue')//轮播图设置
const BulletinBoard = () => import('@/views/marke/BulletinBoard.vue')//小程序首页公告
// 权限
const Power = () => import('@/views/power/Power.vue')//权限
const Admin = () => import('@/views/power/administrators/Administrators.vue')//管理员列表
const Role = () => import('@/views/power/role/Role.vue')//角色列表
// 数据统计
const OnlineStatistics = () => import('@/views/stats/online/OnlineStatistics.vue') //线上数据统计
const OfflineStatistics = () => import('@/views/stats/offline/OfflineStatistics.vue') //门店数据统计
const MallDataStatistics = () => import('@/views/stats/small/MallDataStatistics.vue') //商城数据统计
const RechargeStatistics = () => import('@/views/stats/member/RechargeStatistics.vue') //用户交易统计
const OnlineExport = () => import('@/views/stats/DataExport.vue') //线上订单导出
const OnlineItemExport = () => import('@/views/stats/OnlineExport.vue') //线上衣物表导出
const OfflineExport = () => import('@/views/stats/OfflineExport.vue') //门店订单导出
const SmallExport = () => import('@/views/stats/SmallExport.vue') //商城订单导出
const RechageExport = () => import('@/views/stats/RechageExport.vue') //交易记录导出
// 设置
const Setup = () => import('@/views/setup/Setup.vue') //设置
const Printer = () => import('@/views/setup/printer/Printer.vue') //设置打印机
const GirdNumber = () => import('@/views/setup/gird/GirdNumber.vue') //设置格架号
const Correlation = () => import('@/views/setup/factory/Correlation.vue') //设置工厂关联
const LogisticsList = () => import('@/views/setup/logistics/LogisticsList.vue')//快递物流
const FreeShipping = () => import('@/views/setup/logistics/FreeShipping.vue')//包邮设置
const CompanyAddress = () => import('@/views/order/address/CompanyAddress.vue')//工厂地址列表
const ResourceList = () => import('@/views/produce/resource/ResourceList.vue')//资源列表
const ServiceList = () => import('@/views/produce/resource/ServiceList.vue')//分项服务
Vue.use(VueRouter)


//对外暴露配置路由(常量路由):全部用户都可以访问到的路由 
export const constantRouterMap = [
  // { path: '/', redirect: '/login' },
  { path: '/login', component: Login, meta: { title: '登录' } },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/welcome',
    meta: {
      title: '首页',
      icon: 'icon-shouye'
    },
    children: [
      {
        path: 'welcome', //首页
        name: 'welcome',
        url: '/welcome',
        component: Home,
        meta: {
          title: '首页',
          icon: 'icon-shouye',
          affix: true
        }
      }
    ]
  }
]
// const router = new VueRouter({
//   routes: [
//     { path: '/', redirect: '/login' },
//     { path: '/login', component: Login, meta: { title: '登录' } },
//     {
//       path: '/home',
//       component: Layout,
//       redirect: '/welcome',
//       meta: {
//         title: '首页'
//       },
//       children: [
//         {
//           path: '/welcome', //首页
//           name: 'home',
//           component: Home,
//           meta: {
//             title: '首页'
//           }
//         },
//       ]
//     },
export const asyncRouterMap = [
  {
    path: '/order', //订单
    name: 'order',
    component: Layout,
    alwaysShow: true,
    redirect: '/order/order-list',
    meta: {
      title: '线上',
      id: 1,
      icon: 'icon-dingdan'
    },
    children: [
      {
        path: 'order-list',
        name: 'order-list',
        url: '/order/order-list',
        component: OrderList,
        meta: {
          title: '订单列表',
          id: 2,
          icon: 'icon-dingdanliebiao'
        }
      }, {
        path: 'clothing-list',
        name: 'clothing-list',
        url: '/order/clothing-list',
        component: ClothingList,
        meta: {
          title: '衣物列表',
          id: 3,
          icon: 'icon-skin'
        }
      }, {
        path: 'online-channel',
        name: 'online-channel',
        url: '/order/online-channel',
        component: OnlineProductChannel,
        meta: {
          title: '渠道商品',
          id: 44,
          icon: 'icon-shangpinliebiao'
        }
      }, {
        path: 'commod-list',//访问路径：/commodity/list
        name: 'commod-list',
        url: '/order/commod-list',
        component: CommodityList,
        meta: {
          title: '线上商品库',
          id: 4,
          icon: 'icon-shangpinliebiao'
        }
      }, {
        path: 'category',
        name: 'category',
        url: '/order/category',
        component: Category,
        meta: {
          title: '商品分类',
          id: 5,
          icon: 'icon-shangpinfenlei'
        }
      }
    ]
  }, {
    path: '/produce', //生产
    name: 'produce',
    component: Layout,
    alwaysShow: true,
    redirect: '/produce/clothing-list',
    meta: {
      title: '生产',
      id: 6,
      icon: 'icon-shengchanguanli'
    },
    children: [
      {
        path: 'enter-factory',
        name: 'enter-factory',
        url: '/produce/enter-factory',
        component: EnterFactory,
        meta: {
          title: '线上分检',
          id: 7,
          icon: 'icon-zuixing-40'
        }
      }, {
        path: 'store-sort',
        name: 'store-sort',
        url: '/produce/store-sort',
        component: SortingStore,
        meta: {
          title: '门店分检',
          id: 8,
          icon: 'icon-zuixing-40'
        }
      }, {
        path: 'clothing-inspection',
        name: 'clothing-inspection',
        url: '/produce/clothing-inspection',
        component: ClothingInspection,
        meta: {
          title: '衣物总检',
          id: 9,
          icon: 'icon-icon-test'
        }
      }, {
        path: 'leaving-factory',
        name: 'leaving-factory',
        url: '/produce/leaving-factory',
        component: LeavingFactory,
        meta: {
          title: '线上出厂',
          id: 10,
          icon: 'icon-yichuchang'
        }
      }, {
        path: 'store-outbound',
        name: 'store-outbound',
        url: '/produce/store-outbound',
        component: OutboundStore,
        meta: {
          title: '门店出厂',
          id: 11,
          icon: 'icon-yichuchang'
        }
      }, {
        path: 'place-order-store',
        name: 'place-order-store',
        url: '/produce/place-order-store',
        component: PlaceOrderStore,
        meta: {
          title: '门店下单',
          id: 68,
          icon: 'icon-yichuchang'
        }
      }, {
        path: 'garment-store',
        name: 'garment-store',
        url: '/produce/garment-store',
        component: GarmentStore,
        meta: {
          title: '门店收衣',
          id: 69,
          icon: 'icon-yichuchang'
        }
      }
    ]
  }, {
    path: '/store', //门店管理
    name: 'store',
    component: Layout,
    alwaysShow: true,
    redirect: '/store/store-order',
    meta: {
      title: '门店',
      id: 12,
      icon: 'icon-mendianguanli'
    },
    children: [
      {
        path: 'book-order',
        name: 'book-order',
        url: '/store/book-order',
        component: BookOrder,
        meta: {
          title: '网约订单',
          id: 13,
          icon: 'icon-74wodedingdan'
        }
      }, {
        path: 'store-list',
        name: 'store-list',
        url: '/store/store-list',
        component: StoreParentOrder,
        meta: {
          title: '门店订单',
          id: 71,
          icon: 'icon-mendiandingdan'
        }
      },
      {
        path: 'store-order',
        name: 'store-order',
        url: '/store/store-order',
        component: StoreOrder,
        meta: {
          title: '门店衣物',
          id: 14,
          icon: 'icon-mendiandingdan'
        }
      }, {
        path: 'store-channel',
        name: 'store-channel',
        url: '/store/store-channel',
        component: StoreProductChannel,
        meta: {
          title: '渠道商品',
          id: 45,
          icon: 'icon-mendianshangpinguanli'
        }
      }, {
        path: 'store-product',
        name: 'store-product',
        url: '/store/store-product',
        component: StoreProduct,
        meta: {
          title: '门店商品库',
          id: 15,
          icon: 'icon-mendianshangpinguanli'
        }
      }, {
        path: 'store-commodity',
        name: 'store-commodity',
        url: '/store/store-commodity',
        component: StoreCommodity,
        meta: {
          title: '商品分类',
          id: 16,
          icon: 'icon-shangpinfenlei'
        }
      }, {
        path: 'collection-point',
        name: 'collection-point',
        url: '/store/collection-point',
        component: CollectionPoint,
        meta: {
          title: '门店列表',
          id: 17,
          icon: 'icon-P'
        }
      }
    ]
  },
  // {
  //   path: '/sort', //门店生产
  //   name: 'sort',
  //   component: Layout,
  //   alwaysShow: true,
  //   redirect: '/sort/store-sort',
  //   meta: {
  //     title: '门店生产',
  //     id: 43,
  //     icon: 'icon-shengchanguanli'
  //   },
  //   children: [
  //      {
  //       path: 'store-genneral',
  //       name: 'store-genneral',
  //       url: '/sort/store-genneral',
  //       component: GenneralStore,
  //       meta: {
  //         title: '衣物总检',
  //         id: 45,
  //         icon: 'icon-icon-test'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/mall', //商城
    name: 'mall',
    component: Layout,
    alwaysShow: true,
    redirect: '/mall/mall-order',
    meta: {
      title: '商城',
      id: 18,
      icon: 'icon-shangcheng-copy'
    },
    children: [
      {
        path: 'mall-order',
        name: 'mall-order',
        url: '/mall/mall-order',
        component: MallOrder,
        meta: {
          title: '商城订单',
          id: 19,
          icon: 'icon-shangchengdingdan-'
        }
      }, {
        path: 'mall-channel',
        name: 'mall-channel',
        url: '/mall/mall-channel',
        component: MallProductChannel,
        meta: {
          title: '渠道商品',
          id: 46,
          icon: 'icon-shangchengshangpin'
        }
      },
      {
        path: 'mall-product',
        name: 'mall-product',
        url: '/mall/mall-product',
        component: MallProduct,
        meta: {
          title: '商城商品库',
          id: 20,
          icon: 'icon-shangpinkucun'
        }
      },
      {
        path: 'mall-commodity',
        name: 'mall-commodity',
        url: '/mall/mall-commodity',
        component: MallCommodity,
        meta: {
          title: '商品分类',
          id: 21,
          icon: 'icon-shangpinfenlei'
        }
      }
    ]
  }, {
    path: '/work', //工单
    name: 'work',
    component: Layout,
    alwaysShow: true,
    redirect: '/work/work-list',
    meta: {
      title: '工单',
      id: 22,
      icon: 'icon-a-214-06'
    },
    children: [
      {
        path: 'work-list',
        name: 'work-list',
        url: '/work/work-list',
        component: WorkList,
        meta: {
          title: '工单列表',
          id: 23,
          icon: 'icon-a-mobankubeifen2'
        }
      },
    ]
  }, {
    path: '/user', //用户
    name: 'user',
    component: Layout,
    alwaysShow: true,
    redirect: '/user/user-list',
    meta: {
      title: '用户',
      id: 24,
      icon: 'icon-yonghuguanli'
    },
    children: [
      {
        path: 'user-list',
        name: 'user-list',
        url: '/user/user-list',
        component: UserList,
        meta: {
          title: '用户管理',
          id: 25,
          icon: 'icon-yonghu'
        }
      }, {
        path: 'user-address',
        name: 'user-address',
        url: '/user/user-address',
        component: UserAddress,
        meta: {
          title: '用户地址',
          id: 26,
          icon: 'icon-a-yonghudizhiguanli_huaban1'
        }
      }, {
        path: 'shopping-list',
        name: 'shopping-list',
        url: '/user/shopping-list',
        component: ShoppingList,
        meta: {
          title: '购物车列表',
          id: 27,
          icon: 'icon-gouwuche'
        }
      }
    ]
  }, {
    path: '/marke', //营销
    name: 'marke',
    component: Layout,
    alwaysShow: true,
    redirect: '/marke/member',
    meta: {
      title: '营销',
      id: 28,
      icon: 'icon-yingxiaoguanli'
    },
    children: [
      {
        path: 'member',
        name: 'member',
        url: '/marke/member',
        component: MemberDiscount,
        meta: {
          title: '充值卡',
          id: 29,
          icon: 'icon-huiyuanzhekou'
        }
      },
      {
        path: 'group',
        name: 'group',
        url: '/marke/group',
        component: GroupManage,
        meta: {
          title: '团单管理',
          id: 30,
          icon: 'icon-tuandanzhongxin'
        }
      },
      {
        path: 'commis-sion',
        name: 'commis-sion',
        url: '/marke/commis-sion',
        component: CommissionMember,
        meta: {
          title: '分销管理',
          id: 66,
          icon: 'icon-tuandanzhongxin'
        }
      },
      {
        path: 'distribution-list',
        name: 'distribution-list',
        url: '/marke/distribution-list',
        component: DistributionRecords,
        meta: {
          title: '分销记录',
          id: 72,
          icon: 'icon-tuandanzhongxin'
        }
      },
      {
        path: 'channel-list',
        name: 'channel-list',
        url: '/marke/channel-list',
        component: ChannelList,
        meta: {
          title: '渠道列表',
          id: 47,
          icon: 'icon-tuiguangqudaoliebiao'
        }
      }, {
        path: 'voucher-management',
        name: 'voucher-management',
        url: '/marke/voucher-management',
        component: VoucherManagement,
        meta: {
          title: '代金券管理',
          id: 70,
          icon: 'icon-shouyelunbotu'
        }
      }, {
        path: 'voucher-record',
        name: 'voucher-record',
        url: '/marke/voucher-record',
        component: VoucherRecord,
        meta: {
          title: '代金券记录',
          id: 73,
          icon: 'icon-shouyelunbotu'
        }
      }, {
        path: 'carousel-list',
        name: 'carousel-list',
        url: '/marke/carousel-list',
        component: CarouselImage,
        meta: {
          title: '轮播图设置',
          id: 48,
          icon: 'icon-shouyelunbotu'
        }
      }, {
        path: 'bulletin-board',
        name: 'bulletin-board',
        url: '/marke/bulletin-board',
        component: BulletinBoard,
        meta: {
          title: '小程序公告',
          id: 55,
          icon: 'icon-gonggao'
        }
      }
    ]
  }, {
    path: '/stats', //统计
    name: 'stats',
    component: Layout,
    alwaysShow: true,
    redirect: '/stats/printer',
    meta: {
      title: '统计',
      id: 31,
      icon: 'icon-shujutongji'
    },
    children: [
      {
        path: 'online-statistics',
        name: 'online-statistics',
        component: OnlineStatistics,
        url: '/stats/online-statistics',
        meta: {
          title: '线上数据统计',
          id: 32,
          icon: 'icon-shujutongji3'
        }
      },
      {
        path: 'offline-statistics',
        name: 'offline-statistics',
        component: OfflineStatistics,
        url: '/stats/offline-statistics',
        meta: {
          title: '门店数据统计',
          id: 56,
          icon: 'icon-shujutongji3'
        }
      },
      {
        path: 'small-statistics',
        name: 'small-statistics',
        component: MallDataStatistics,
        url: '/stats/small-statistics',
        meta: {
          title: '商城数据统计',
          id: 67,
          icon: 'icon-shujutongji3'
        }
      },
      {
        path: 'member-statistics',
        name: 'member-statistics',
        component: RechargeStatistics,
        url: '/stats/member-statistics',
        meta: {
          title: '用户交易统计',
          id: 57,
          icon: 'icon-shujutongji3'
        }
      },
      {
        path: 'data-export',
        name: 'data-export',
        url: '/stats/data-export',
        component: OnlineExport,
        meta: {
          title: '线上表导出',
          id: 33,
          icon: 'icon-nav_icon_shujudaochu'
        }
      }, {
        path: 'online-export',
        name: 'online-export',
        url: '/stats/online-export',
        component: OnlineItemExport,
        meta: {
          title: '线上衣物表',
          id: 54,
          icon: 'icon-nav_icon_shujudaochu'
        }
      }, {
        path: 'offline-export',
        name: 'offline-export',
        url: '/stats/offline-export',
        component: OfflineExport,
        meta: {
          title: '门店表导出',
          id: 51,
          icon: 'icon-nav_icon_shujudaochu'
        }
      }, {
        path: 'small-export',
        name: 'small-export',
        url: '/stats/small-export',
        component: SmallExport,
        meta: {
          title: '商城表导出',
          id: 52,
          icon: 'icon-nav_icon_shujudaochu'
        }
      }, {
        path: 'rechage-export',
        name: 'rechage-export',
        url: '/stats/rechage-export',
        component: RechageExport,
        meta: {
          title: '交易表导出',
          id: 53,
          icon: 'icon-nav_icon_shujudaochu'
        }
      }
    ]
  }, {
    path: '/power', //权限
    name: 'power',
    component: Layout,
    alwaysShow: true,
    redirect: '/power/admin',
    meta: {
      title: '权限',
      id: 34,
      icon: 'icon-quanxian'
    },
    children: [
      {
        path: 'admin',
        name: 'admin',
        url: '/power/admin',
        component: Admin,
        meta: {
          title: '员工管理',
          id: 35,
          icon: 'icon-guanliyuan'
        }
      }, {
        path: 'role',
        name: 'role',
        url: '/power/role',
        component: Role,
        meta: {
          title: '角色设置',
          id: 36,
          icon: 'icon-jiaoseliebiao'
        }
      }
    ]
  }, {
    path: '/setup', //设置
    name: 'setup',
    component: Layout,
    alwaysShow: true,
    redirect: '/setup/printer',
    meta: {
      title: '设置',
      id: 37,
      icon: 'icon-shezhi2'
    },
    children: [
      {
        path: 'printer',
        name: 'printer',
        url: '/setup/printer',
        component: Printer,
        meta: {
          title: '打印机',
          id: 38,
          icon: 'icon-24px'
        }
      }, {
        path: 'gird-number',
        name: 'gird-number',
        url: '/setup/gird-number',
        component: GirdNumber,
        meta: {
          title: '格架号',
          id: 39,
          icon: 'icon-zhage'
        }
      }, {
        path: 'service-list',
        name: 'service-list',
        url: '/setup/service-list',
        component: ServiceList,
        meta: {
          title: '分项服务',
          id: 61,
          icon: 'icon-ziyuan-xianxing'
        }
      }, {
        path: 'resource-list',
        name: 'resource-list',
        url: '/setup/resource-list',
        component: ResourceList,
        meta: {
          title: '资源列表',
          id: 40,
          icon: 'icon-ziyuan-xianxing'
        }
      }, {
        path: 'correlation',
        name: 'correlation',
        url: '/setup/correlation',
        component: Correlation,
        meta: {
          title: '工厂关联',
          id: 41,
          icon: 'icon-gongchang'
        }
      }, {
        path: 'company-address',
        name: 'company-address',
        url: '/setup/company-address',
        component: CompanyAddress,
        meta: {
          title: '工厂地址',
          id: 42,
          icon: 'icon-gongsidizhi'
        }
      }, {
        path: 'logistics-list',
        name: 'logistics-list',
        url: '/setup/logistics-list',
        component: LogisticsList,
        meta: {
          title: '快递物流',
          id: 43,
          icon: 'icon-wuliuxinxi'
        }
      }, {
        path: 'free-shipping',
        name: 'free-shipping',
        url: '/setup/free-shipping',
        component: FreeShipping,
        meta: {
          title: '包邮设置',
          id: 49,
          icon: 'icon-baoyou'
        }
      }
      // , {
      //   path: 'add-companyAddr',
      //   name: 'add-companyAddr',
      //   component: CompanyAddrAdd,
      //   meta: {
      //     title: '新增工厂地址'
      //   },
      //   hidden: true
      // }
    ]
  }, {
    path: '/supplier', //供应商
    name: 'supplier',
    component: Layout,
    alwaysShow: true,
    redirect: '/supplier/internal-order',
    meta: {
      title: '供应商',
      id: 60,
      icon: 'icon-gongyingshang-zhanghao'
    },
    children: [
      {
        path: 'internal-order',
        name: 'internal-order',
        url: '/supplier/internal-order',
        component: InternalShipment,
        meta: {
          title: '供应商发货',
          id: 50,
          icon: 'icon-gongqiudating-gongying'
        }
      }, {
        path: 'supplier-account',
        name: 'supplier-account',
        url: '/supplier/supplier-account',
        component: SupplierAccount,
        meta: {
          title: '供应商快递',
          id: 58,
          icon: 'icon-gongyingshang-zhanghao'
        }
      }, {
        path: 'supplier-company',
        name: 'supplier-company',
        url: '/supplier/supplier-company',
        component: SupplierCompany,
        meta: {
          title: '供应商公司',
          id: 59,
          icon: 'icon-gongyingshanggongsi'
        }
      }
    ]
  }, {
    path: '/channel', //渠道订单
    name: 'channel',
    component: Layout,
    alwaysShow: true,
    redirect: '/channel/online-order',
    meta: {
      title: '渠道订单',
      id: 62,
      icon: 'icon-dingdan'
    },
    children: [
      {
        path: 'online-order',
        name: 'online-order',
        url: '/channel/online-order',
        component: OnlineOrder,
        meta: {
          title: '线上订单',
          id: 63,
          icon: 'icon-dingdanliebiao'
        }
      }, {
        path: 'offline-order',
        name: 'offline-order',
        url: '/channel/offline-order',
        component: OfflineOrder,
        meta: {
          title: '门店订单',
          id: 64,
          icon: 'icon-mendiandingdan'
        }
      }, {
        path: 'small-order',
        name: 'small-order',
        url: '/channel/small-order',
        component: MallSmallOrder,
        meta: {
          title: '商城订单',
          id: 65,
          icon: 'icon-shangchengdingdan-'
        }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]
// }
//   ]
// })

const router = new VueRouter({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
// 挂载路由导航守卫
// router.beforeEach((to, from, next) => {
//   // to 表示将要访问的路径
//   // from 代表从哪个路径跳转而来
//   // next 是一个函数，表示放行
//   // next()  放行  next('/login') 强制跳转
//   if (to.path === '/login') return next()
//   // 获取token
//   const tokenStr = window.sessionStorage.getItem('token')
//   if (!tokenStr) return next('/login')
//   return next()
// })


export default router
